<template>
  <div class="main-layout" :style="{ height: !isDesktop ? windowHeight + 'px' : '100vh' }">
    <div v-if="!isEmbedMode" class="main-layout-header">
      <LayoutHeader />
    </div>
    <div class="main-layout-content" ref="mainLayoutContent" id="main-layout-content">
      <div style="flex: 1;">
        <slot />
      </div>
      <LayoutFooter v-if="!isEmbedMode" />
    </div>

    <client-only>
      <el-backtop :right="25" :bottom="130" target="#main-layout-content" style="width: 60px;height: 60px;">
        <div class="desktop-backtop-icon">
          <i class="iconfont icon-icon_icon_to2" />
        </div>
      </el-backtop>
    </client-only>
  </div>
</template>
  
  <script setup lang="ts">
  import eventBus from 'vue3-eventbus'
  import { EventEditorHomeBottom } from '~/config/event'
  import { useEmbedMode } from '~/composables/useEmbedMode'

  const { isEmbedMode } = useEmbedMode()
  const route = useRoute()
  const mainLayoutContent = ref<HTMLElement | null>(null)
  // 这里监听路由变化，如果路由变化，则滚动到顶部
  watch(route, () => {
    handleEditorHomeBottom()
  })

  const handleEditorHomeBottom = () => {
    if (mainLayoutContent.value) {
      mainLayoutContent.value.scrollTop = 0
    }
  }

  onMounted(() => {
    eventBus.on(EventEditorHomeBottom.editorHomeBottom, handleEditorHomeBottom)
    windowHeight.value = window.innerHeight
  })

  onUnmounted(() => {
    eventBus.off(EventEditorHomeBottom.editorHomeBottom, handleEditorHomeBottom)
  })


  const viewport = useViewport();
  const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'));
  // 获取窗口可用高度
  const windowHeight = ref(0)
  

  </script>
  
  <style scoped lang="scss">
  .main-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    .main-layout-header {
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 100;
    }
    .main-layout-content {
      flex: 1;
      overflow-y: auto;
      width: 100%;
      min-height: 400px;
      display: flex;
      flex-direction: column;
    }
    .desktop-container-wrapper {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }
  }
  .desktop-backtop-icon{
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.16);
      border-radius: 50%;
      .iconfont{
        font-size: 36px !important;
        color: #2590E1;
      }
    }
  </style>
